module.exports = __webpack_public_path__ + "img/icon-zhedie.c10abeb3.svg";